import { authHeader } from '@/_helpers'

const apiUrl = process.env.VUE_APP_ROOT_API

export const adminSystemChatService = {
  sendChat,
  getCodebaseTree,
  getCodebaseFile,
}

function sendChat(message, history = []) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ message, history }),
  }
  return fetch(`${apiUrl}/admin-system-chat/chat`, requestOptions).then(handleResponse)
}

function getCodebaseTree(path = '', maxDepth = 4) {
  const q = new URLSearchParams()
  if (path) q.set('path', path)
  q.set('max_depth', String(maxDepth))
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/admin-system-chat/codebase/tree?${q.toString()}`, requestOptions).then(handleResponse)
}

function getCodebaseFile(path) {
  const q = new URLSearchParams({ path })
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/admin-system-chat/codebase/file?${q.toString()}`, requestOptions).then(handleResponse)
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      return Promise.reject(data || response.statusText)
    }
    return data
  })
}
